import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { adminLogin } from "../lib/api";
import { tokenStorage } from "../lib/tokenStorage";

function applyAdminSeo() {
  document.title = "Connexion Admin — GMC Rénovation Façade";
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    document.head.appendChild(robots);
  }
  robots.setAttribute("content", "noindex, nofollow");
  let desc = document.querySelector('meta[name="description"]');
  if (desc) {
    desc.setAttribute(
      "content",
      "Espace administrateur GMC Rénovation Façade — accès réservé."
    );
  }
}

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    applyAdminSeo();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(email, password);
      tokenStorage.set(token);
      toast.success("Connecté");
      nav("/admin");
    } catch (e) {
      toast.error("Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#050505] px-6 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(circle at 50% 0%, rgba(255,90,0,0.2) 0%, transparent 50%)",
        }}
      />
      <Link
        to="/"
        data-testid="admin-back-link"
        className="absolute top-6 left-6 flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors"
      >
        <ArrowLeft size={14} /> Retour au site
      </Link>

      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="relative glass-strong rounded-3xl p-10 w-full max-w-md"
      >
        <div className="w-14 h-14 rounded-full bg-[#FF5A00]/10 border border-[#FF5A00]/30 flex items-center justify-center mb-6 mx-auto">
          <Lock size={20} className="text-[#FF5A00]" />
        </div>
        <h1 className="font-display text-3xl text-center text-white mb-2">
          Espace administrateur
        </h1>
        <p className="text-sm text-neutral-400 text-center mb-8">
          GMC Rénovation Façade
        </p>

        <div className="space-y-6 mb-8">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-neutral-500 block mb-2">
              Email
            </label>
            <input
              data-testid="admin-input-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-line"
              placeholder="admin@gmc-renovation.fr"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-neutral-500 block mb-2">
              Mot de passe
            </label>
            <input
              data-testid="admin-input-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-line"
              placeholder="••••••••"
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="btn-primary w-full justify-center disabled:opacity-50"
        >
          {loading ? (
            <>
              <Loader2 size={16} className="animate-spin" /> Connexion…
            </>
          ) : (
            "Se connecter"
          )}
        </button>
      </form>
    </div>
  );
}
